import { Controller } from '@hotwired/stimulus';

export default class extends Controller<HTMLElement> {
  static readonly targets = ['control', 'target'];
  static readonly values = {
    invert: Boolean,
    disableOnToggle: Boolean,
  };

  declare controlTarget: HTMLElement;
  declare targetTarget: HTMLElement;
  declare invertValue: boolean;
  declare disableOnToggleValue: boolean;

  private open = false;
  private invert = false;

  initialize() {
    if (!this.targetTarget.id) {
      this.targetTarget.id = crypto.randomUUID();
    }
    this.controlTarget.setAttribute('aria-controls', this.targetTarget.id);

    this.invert = this.invertValue ?? false;

    this.stateFromDom();
  }

  toggle() {
    this.open = !this.open;
    this.applyState();
  }

  private stateFromDom() {
    if (isCheckbox(this.controlTarget)) {
      const checkControl = this.controlTarget as HTMLInputElement;
      this.open = this.invert ? !checkControl.checked : checkControl.checked;
    } else {
      const value = this.controlTarget.dataset.expanded === 'true';
      this.open = value;
    }

    this.applyState();
  }

  private applyState() {
    this.controlTarget.dataset.expanded = this.open.toString();
    this.targetTarget.hidden = !this.open;

    // TODO: Refactor
    if (this.disableOnToggleValue && isFieldset(this.targetTarget)) {
      (this.targetTarget as HTMLFieldSetElement).disabled = !this.open;
    }
  }
}

function isCheckbox(element: HTMLElement) {
  return element instanceof HTMLInputElement && element.type === 'checkbox';
}

function isFieldset(element: HTMLElement) {
  return element instanceof HTMLFieldSetElement && element.type === 'fieldset';
}
